<template>
    <span class="d-flex">
        <template v-if="service.serviceType === 'EXTRASERVICE'">
            <v-icon color="primary" start>
                {{ 'mdi-cloud-off-outline' }}
            </v-icon>
            <v-icon color="primary" start>
                {{ extraServiceTypeIcon }}
            </v-icon>
        </template>
        <v-icon v-else color="primary" start>
            {{ serviceTypeIcon }}
        </v-icon>
    </span>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'
    import {getServiceTypeIcon} from '~src/utils/helpers'

    @Component
    export class ServiceIcon extends Vue {
        @Prop({required: true, type: Object}) service

        get serviceTypeIcon() {
            return getServiceTypeIcon(this.service)
        }

        get extraServiceTypeIcon() {
            return getServiceTypeIcon({serviceType: this.service.serviceDetails[0]?.extraServiceProductType})
        }
    }

    export default ServiceIcon
</script>
